import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: 'form-viewer/:owner/:code',
    loadChildren: () =>
      import('./pages/form-viewer/form-viewer.module').then(
        (m) => m.FormViewerModule
      ),
  },
  {
    path: 'form-viewer/:owner/:code/:version?',
    loadChildren: () =>
      import('./pages/form-viewer/form-viewer.module').then(
        (m) => m.FormViewerModule
      ),
  },
  {
    path: 'login-dashboard',
    loadChildren: () =>
      import('./pages/auth/dashboard-login/dashboard-login.module').then(
        (m) => m.DashboardLoginModule
      ),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/auth/register/register.module').then(
        (m) => m.RegisterModule
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/auth/form-viewer-login/form-viewer-login.module').then(
        (m) => m.FormViewerLoginModule
      ),
  },
  {
    canActivate: [AuthGuard],
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'leads',
    loadChildren: () =>
      import('./pages/leads/leads.module').then((m) => m.LeadsModule),
  },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
